import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "k-game-timer" }
const _hoisted_2 = { class: "k-game-timer__time" }
const _hoisted_3 = { class: "k-game-timer__label" }
const _hoisted_4 = { class: "flex-centered" }
const _hoisted_5 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "bi bi-infinity",
  viewBox: "0 0 16 16"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", { d: "M5.68 5.792 7.345 7.75 5.681 9.708a2.75 2.75 0 1 1 0-3.916ZM8 6.978 6.416 5.113l-.014-.015a3.75 3.75 0 1 0 0 5.304l.014-.015L8 8.522l1.584 1.865.014.015a3.75 3.75 0 1 0 0-5.304l-.014.015L8 6.978Zm.656.772 1.663-1.958a2.75 2.75 0 1 1 0 3.916L8.656 7.75Z" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

import { computed, ref, nextTick, reactive, watch, onMounted } from 'vue';
import { useModule } from 'src/modules/modules';


export default /*#__PURE__*/_defineComponent({
  __name: 'game-timer',
  props: {
    infinite: Boolean,
    highContrast: Boolean
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "98146136": (_unref(trackBg)),
  "de71a31e": (_unref(theme).values.timerFillBg)
}))

const { game, theme } = useModule();



const fillStyleComputed = computed(() => {
    let fillPercentReversed : number = 100;
    if (props.infinite || game.clock.status === 'stopped'){
        fillPercentReversed = 0;
    } else {
        fillPercentReversed = 100 - (game.clock.progress * 100);
    }

    //let fillPercentReversed = props.infinite || game.clock.status === 'stopped' ? 0 : 100 - (game.clock.progress * 100);
    return {
        clipPath: `inset(0px ${fillPercentReversed}% 0px 0px)`
        // width: `${fillPercent}%`
    }
})

// const fill = ref();
// watch(() => fillStyleComputed.value, () => {
//     fill.value.style.clipPath = fillStyleComputed.value.clipPath;
// })

// const secondsRemaining = computed(() => {
//     let sec = Math.floor(game.clock.remaining / 1000);
//     if (game.clock.remaining === 0){
//         return '';
//     }
//     return `${sec + 1}`;
// })

const trackBg = props.highContrast ? '#0000006c' : theme.theme.cardBg;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "k-game-timer__track",
        style: _normalizeStyle({ background: _unref(theme).values.timerTrackBg })
      }, [
        _createElementVNode("div", {
          class: "k-game-timer__fill",
          style: _normalizeStyle(_unref(fillStyleComputed))
        }, null, 4),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (__props.infinite)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true)
          ])
        ])
      ], 4)
    ])
  ]))
}
}

})